import * as React from "react";
const SvgFiRrGarageCar = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-garage-car_svg__a)">
      <path
        fill="#062147"
        d="m21.8 5.579-7-4.724a4.98 4.98 0 0 0-5.6 0l-7 4.724A4.99 4.99 0 0 0 0 9.724V19a5.006 5.006 0 0 0 5 5 1 1 0 0 0 1-1V13a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v10a1 1 0 0 0 1 1 5.006 5.006 0 0 0 5-5V9.724a5 5 0 0 0-2.2-4.145m.2 13.42a3.01 3.01 0 0 1-2 2.83v-8.83a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v8.83a3.01 3.01 0 0 1-2-2.83V9.725a3 3 0 0 1 1.322-2.487l7-4.723a2.98 2.98 0 0 1 3.356 0l7 4.723A3 3 0 0 1 22 9.724zm-6.1-2.906A2.99 2.99 0 0 0 13.036 14h-2.072A2.99 2.99 0 0 0 8.1 16.093l-.672 2.119C7.205 19.31 6.256 21.814 8 22v1a1 1 0 0 0 2 0v-1h4v1a1 1 0 0 0 2 0v-1c1.744-.188.8-2.688.568-3.79zM10.964 16h2.072a1 1 0 0 1 .953.7L14.4 18H9.6l.414-1.3a1 1 0 0 1 .95-.7"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-garage-car_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrGarageCar;
